// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"6dfc6d4b","453":"694e132d","633":"4aeba741"}[chunkId] + ".chunk.js";
};